import Core from "Core";

export class ApplicationsStore extends Core.Stores.ModelStore {
  constructor(modelType, store) {
    super(modelType, "/api/public/applications.php", store);
  }

  beforeUpdateFromJson() {
    this.clear();
  }
}



// WEBPACK FOOTER //
// ./src/Stores/DataStore/ApplicationsStore.js